var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureStreamlineIconLightBulb1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 64,
    viewBox: "0 0 48 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-light-bulb-1_64x64",
    "data-name": "streamline-icon-light-bulb-1@64x64",
    transform: "translate(-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M38,56a6,6,0,0,1-12,0V46H38Z",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M38,46A23.037,23.037,0,0,0,54,24a22,22,0,1,0-44,0A23.037,23.037,0,0,0,26,46",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M28,26H24a4,4,0,1,1,4-4Z",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M36,26h4a4,4,0,1,0-4-4Z",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M28,46V26h8V46",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M26,54H38",
    fill: "none",
    stroke: "#5f5cd7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureStreamlineIconLightBulb1);
export default __webpack_public_path__ + "static/media/feature-streamline-icon-light-bulb-1.6c97a727.svg";
export { ForwardRef as ReactComponent };